import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { tap } from 'rxjs/operators';
import { AuthenticationTokenStorageService } from '../session-storage/authentication.token.storage.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private authenticationTokenStorageService: AuthenticationTokenStorageService,
    private router: Router
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req;
    if (this.authenticationTokenStorageService.getToken() != null) {
      authReq = req.clone({
        headers: req.headers.set(
          TOKEN_HEADER_KEY,
          'Bearer ' + this.authenticationTokenStorageService.getToken()
        ),
      });
    }
    return next.handle(authReq).pipe(
      tap((ev: HttpEvent<any>) => {
        if (ev instanceof HttpErrorResponse) {
          if (ev.status === 401) {
            this.router.navigate(['user']);
          }
        }
      })
    );
  }
}
